/**
 * Ohne Kollektivvertrag — nur, was das Gesetz vorgibt (AZG, ARG).
 *
 * Die zweite Vorlage neben dem Metallgewerbe. Sie ist bewusst karg: Normalarbeitszeit
 * 40 Stunden ohne Mehrarbeitsband, Überstunden mit 50 %, Teilzeit-Mehrarbeit mit 25 %,
 * keine Zulagen, kein abweichender Überstundenteiler. Sie zeigt, dass ein anderer
 * Vertrag ein anderer Satz Werte ist — und dient als Ausgangspunkt für Betriebe ohne KV.
 */
import { BETRIEBSZEITEN_DEFAULT } from '../konfig'
import type { KvVorlage } from './typen'

export const AT_GESETZ: KvVorlage = {
  schluessel: 'AT_GESETZ',
  name: 'Ohne Kollektivvertrag — gesetzlicher Standard (AZG, ARG)',
  kurz: 'Gesetz',
  fassung: 'AZG und ARG, Stand 2026',
  quelle: 'ris.bka.gv.at — Arbeitszeitgesetz, Arbeitsruhegesetz',
  wertsaetze: [
    {
      gueltigAb: '1900-01-01',
      werte: {
        pause_aktiv: '1',
        pause_dauer: '30',
        pause_schwelle: '6',

        ueberstunden_zeitraum: 'woechentlich',
        ueberstunden_zeitraum_monate: '3',
        // Kein Band zwischen Normalarbeitszeit und Überstunde: beide Schwellen bei 40 h.
        mehrarbeit_schwelle: '40',
        ueberstunden_schwelle: '40',
        mehrzeit_zuschlag_vollzeit: '0',
        mehrzeit_zuschlag_teilzeit: '25',
        // Die Überstunde wird mit demselben Teiler gerechnet wie die Normalstunde.
        umrechnung_zaehler: '1',
        umrechnung_nenner: '1',

        zuschlag_ueberstunde: '50',
        zuschlag_regeln: '[]',
        sonntag_prozent: '0',
        feiertag_prozent: '100',
        zuschlag_ausserhalb_betriebszeit: '0',
        betriebszeiten: JSON.stringify(BETRIEBSZEITEN_DEFAULT),
        // Die Sonderregeln des Metallgewerbes kennt das Gesetz nicht.
        mehrarbeit_ueber_50_ist_ueberstunde: '0',
        ueberstunde_ab_zaehlt_mehrarbeit: '0',
        ueberstunde_100_arbeitsfrei_ab_stunde: '0',
        ueberstunde_100_ab_wochenstunde: '0',
        rueckruf_prozent: '50',
        halbtag_aktiv: '0',
        halbtag_ende: '12:00',
        halbtag_prozent: '100',

        montagezulage_satz: '0',
        entfernungszulage_klein: '0',
        entfernungszulage_mittel: '0',
        entfernungszulage_gross: '0',
        entfernungszulage_schwelle_klein: '6',
        entfernungszulage_schwelle_mittel: '11',
        entfernungszulage_anreise_grenze: '12:00',
        entfernungszulage_rueckreise_grenze: '17:00',
        entfernungszulage_klein_mit_pause: '0',
        entfernungszulage_verpflegung_prozent: '100',

        rundung_aktiv: '0',
        rundung_schritt: '15',
      },
    },
  ],
  // Zulagen kennt das Gesetz nicht — sie kommen aus einem Kollektivvertrag.
  zulagen: [],
  fundstellen: {
    pause_aktiv: '§ 11 AZG',
    pause_dauer: '§ 11 AZG',
    pause_schwelle: '§ 11 AZG',
    mehrarbeit_schwelle: '§ 3 AZG',
    ueberstunden_schwelle: '§ 6 AZG',
    mehrzeit_zuschlag_teilzeit: '§ 19d AZG',
    zuschlag_ueberstunde: '§ 10 AZG',
    feiertag_prozent: '§ 9 ARG',
  },
}
